import SuperRepository from '../superRepository'

export default new (class GeneratedLinksRepository extends SuperRepository {
  baseUri() {
    return 'generated_link'
  }
  getOffers = ({ signal, ...data }) => this.httpClient().post(this.baseUri() + '/get_offers', data, { signal })
  generateLink = ({ signal, ...data }) => this.httpClient().post(this.baseUri() + '/generate_link', data, { signal })
})()
